<template>
  <div id="eventsList" class="searchresult table-responsive">
    <div v-if="loading" class="message--info">
      <p>Die Daten werden aktuell geladen. Einen Moment Geduld bitte</p>
      <svg class="spinner-land" viewBox="0 0 50 50">
        <circle class="stroke"></circle>
      </svg>
    </div>

    <template v-else-if="events.length > 0">
      <ul class="list--clean">
        <li v-for="event in paginatedEvents" :key="event.id">

          <div class="modul-card">
            <div class="card__body">
              <div class="inner">

                <h3 class="title">
                  {{ event.title }}
                </h3>

                <ul class="cart__status status">
                  <li v-if="event.isUpcoming">
                    <span class="pill pill--message pill--inverted">
                      Ankündigung
                    </span>
                  </li>

                  <li v-if="isCanceledOnSelectedDate(event)">
                    <span class="pill pill--error pill--inverted">
                      Abgesagt
                    </span>
                  </li>

                  <li> <EventTypePill :eventType="event.eventType" /> </li>
                </ul>

                <p>
                  {{ event.description }}
                </p>

                <p v-if="event.isUpcoming">
                  Wird angeboten ab {{ event.startDateHuman }}.
                </p>

                <dl class="list--horizontal block--nogap">
                  <dt>Termine</dt>
                  <dd>
                    <ul class="list--tablelist">

                      <template v-for="(index, day) in days">
                        <li v-if="event.wdayData[`enabled_${index}`] == 1">
                          <div class="cell">
                            {{ day }}s
                          </div>
                          <div class="cell">
                            <span>
                              {{ event.wdayData[`start_time_${index}`] }}
                              –
                              {{ event.wdayData[`end_time_${index}`] }} Uhr
                            </span>
                          </div>
                        </li>
                      </template>

                    </ul>
                  </dd>

                  <dt>Ort</dt>
                  <dd v-if="event.district">{{ event.park }}, {{ event.district }}</dd>
                  <dd v-else>{{ event.park }}</dd>

                  <dt>Zielgruppe</dt>
                  <dd>{{ event.audiences }}</dd>
                </dl>

              </div>
            </div>

            <div class="card__footer">
              <div class="row leftandright center">
                <div class="left">
                  <strong>{{ event.club }}</strong>
                </div>
                <div class="right">
                  <EventDetailsLink :event="event" className="button button--light"/>
                </div>
              </div>
            </div>

          </div>
        </li>
      </ul>

      <nav class="pagination" aria-label="Seite wechseln" v-if="eventsPages > 1">
        <ul>
          <li :aria-disabled="currentEventPage == 1" :class="{disabled: currentEventPage == 1}"
              class="pager-item-previous">
            <a @keyup.enter="setCurrentPage(currentEventPage-1)" @click="setCurrentPage(currentEventPage-1)"
               v-if="currentEventPage != 1" title="Seite zurück blättern" role="button" tabindex="0"><i
                class="fas fa-chevron-left" aria-hidden="true"></i></a>
            <div v-else><i class="fas fa-chevron-left" aria-hidden="true"></i> <span class="aural">Seite zurück</span>
            </div>
          </li>
          <li :rel="(p == eventsPages ? 'last' : '')" :class="{active: currentEventPage == p }"
              :aria-current="currentEventPage == p ? 'page': ''" v-for="p in eventsPages">
            <a @keyup.enter="setCurrentPage(currentEventPage)" @click="setCurrentPage(p)" role="button" tabindex="0">{{
                p
              }}</a>
          </li>
          <li class="mobile-counter"><span>{{ currentEventPage }} / {{ eventsPages }}</span></li>
          <li class="pager-item-next" :aria-disabled="currentEventPage == eventsPages"
              :class="{disabled: currentEventPage == eventsPages}">
            <a @keyup.enter="setCurrentPage(currentEventPage+1)" @click="setCurrentPage(currentEventPage+1)"
               v-if="currentEventPage != eventsPages" title="Seite weiter blättern" role="button" tabindex="0"><i
                class="fas fa-chevron-right" aria-hidden="true"></i></a>
            <div v-else><i class="fas fa-chevron-right" aria-hidden="true"></i> <span
                class="aural">Seite weiter</span></div>
          </li>
        </ul>
      </nav>
    </template>

    <div class="message--error" v-else-if="context != 'similar'">
      <h2 class="title">Keine Ergebnisse gefunden</h2>
      <p>Für Ihre aktuellen Filterkriterien haben wir derzeit leider kein Angebot.</p>
    </div>
  </div>
</template>

<script>
import EventTypePill from './event_type_pill.vue'
import EventDetailsLink from './event_details_link.vue'

export default {
  components: {
    EventTypePill,
    EventDetailsLink
  },
  props: {
    events: {
      type: Array,
      default: () => {
        return []
      }
    },
    context: {
      type: String,
      default: 'index'
    },
    loading: {
      type: Boolean,
      default: true
    },
    selectedDate: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      days: {'Montag': 1, 'Dienstag': 2, 'Mittwoch': 3, 'Donnerstag': 4, 'Freitag': 5, 'Samstag': 6, 'Sonntag': 0},
      eventsCount: 20,
      currentEventPage: 1
    }
  },
  methods: {
    setCurrentPage(page) {
      this.currentEventPage = page
    },
    isCanceledOnSelectedDate(event) {
      if (!this.selectedDate) return false
      if (!event.canceledDates.length) return false

      return event.canceledDates.includes(this.selectedDate)
    },
  },
  computed: {
    eventsPages() {
      return Math.ceil(this.events.length / this.eventsCount)
    },
    paginatedEvents() {
      let from = (this.currentEventPage - 1) * this.eventsCount
      let to = from + this.eventsCount
      return this.events.slice(from, to)
    },
  }
}
</script>
